const Upload = ({ elemRef, handleFile }) => {
  return (
    <input
      type="file"
      ref={elemRef}
      style={{ width: 0, height: 0, opacity: 0 }}
      onChange={handleFile}
    />
  );
};

export default Upload;
